import { Button } from 'antd';
import React from 'react';

interface Props {
	children?: React.ReactNode;
	icon?: React.ReactNode;
	disabled?: boolean;
	danger?: boolean;
	onClick: () => Promise<unknown>;
}

export const AsyncButton: React.FC<Props> = ({ children, icon, disabled, danger, onClick }) => {
	const [loading, setLoading] = React.useState(false);

	const _onClick = async () => {
		if (loading || disabled) {
			return;
		}

		try {
			setLoading(true);
			await onClick();
		} finally {
			setLoading(false);
		}
	};

	return (
		<Button
			type="primary"
			size="large"
			danger={danger ?? false}
			icon={icon}
			onClick={_onClick}
			loading={loading}
			disabled={disabled ?? false}
		>
			{children}
		</Button>
	);
};
